<template>
    <div class="next findPassword">
        <div class="title">
            <span> {{ $t('login.forgetPsw') }} </span>
            <div class="fixed" @click="goBack">
                <svg t="1658129167849" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    p-id="12456" width="0.35rem" height="0.35rem">
                    <path
                        d="M245.01248 555.52512l447.0784 447.0784c22.42048 22.42048 58.81856 22.42048 81.31584 0 22.42048-22.42048 22.42048-58.81856 0-81.31584l-406.49216-406.4256 406.49728-406.49216c22.42048-22.42048 22.42048-58.81856 0-81.31584-22.42048-22.42048-58.81856-22.42048-81.31584 0L244.9408 474.20928c-22.43584 22.47168-22.40512 58.88 0.07168 81.31584 0-0.00512 0 0 0 0z"
                        fill="#666666" p-id="12457"></path>
                </svg>
            </div>
        </div>

        <div class="findPasswordBox">
            <div v-show="type==1" style="text-align: center;">{{ $t('my.confirmYourPhoneTips') }}</div>
            <van-field v-model.trim="code" :maxlength="4" autocomplete="off" :placeholder="$t('register.entryCodeTips')">
                <template #button>
                    <van-button color="#f86fab" @click="confirmGetCode('sendVcode')" v-show="isGetCode" round size="small"
                        type="primary">{{ $t('common.getCode') }}</van-button>
                    <van-button v-show="!isGetCode" disabled color="#f86fab" round size="small"
                        type="primary">{{ getCodeVal }}</van-button>
                </template>
            </van-field>
            <p class="pswTip">{{ $t('login.findPassword.codeSend') }} {{ showAccount }}</p>

            <p class="sexLoginPsw">{{ $t('my.setNewPwd') }}</p>

            <password-input
              v-model="password"
              :max-length="12"
              :placeholder="$t('login.findPassword.userNewPasswordTips')"
              :close-icon="require('../assets/img/eyeCloseR.png')"
              :open-icon="require('../assets/img/eyeOpen.png')"
            />

            <password-input
              v-model="confirmPassword"
              :max-length="12"
              :placeholder="$t('login.findPassword.userNewPasswordTips')"
              :close-icon="require('../assets/img/eyeCloseR.png')"
              :open-icon="require('../assets/img/eyeOpen.png')"
            />

            <p class="pswTip">{{ $t('login.findPassword.moreThan6Tips') }}</p>

            <div @click="confirm" :class="{ 'hasValue': isCanGo }" class="infoConfirm confirmBtn">{{ $t('common.confirm') }}
            </div>
        </div>
        <div style="display: none;" id="captcha"></div>
    </div>
</template>

<script>
import md5 from 'js-md5';
import utils from "@/utils/index";
import { sendVcode, sendEmailVcode, resetEmailPwd, resetPhonePwd } from "@/api/index";
import captcha from '@/pages/mixin/captcha';
import passwordInput from '../components/passwordInput.vue'
export default {
    mixins: [captcha],
    components: {
        passwordInput
    },
    data() {
        return {
            code: "",
            password: "",
            confirmPassword: "",
            account: "",
            isGetCode: true,
            getCodeVal: this.$t('common.getCode'),
            timer: null,
            type: 1, //1手机 2邮箱
            fromPath: ""
        }
    },
    computed: {
        isCanGo() {
            return this.code && this.password && this.confirmPassword;
        },
        showAccount() {
            let account = this.account;
            let phonerReg = /^0\d{9}$/,
                emailReg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
            if(phonerReg.test(account)) {
                account = utils.phoneHide(account);
            }

            if(emailReg.test(account)) {
                account = utils.emailHide(account);
            }

            return account;
        }
    },
    created() {
        this.initializeAccountType();
        this.userCaptcha('sendVcode');
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fromPath = from.path;
        });
    },
    methods: {
        initializeAccountType() {
            if (this.$route.query.username) {
                this.account = this.$route.query.username;
                const emailReg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
                if (emailReg.test(this.account)) {
                    this.type = 2;
                }
            }
        },
        goOtherPage(path) {
            this.$router.push(path);
        },
        // 返回逻辑
        goBack() {
            const paths = ['/login', '/mine/setting/password'];
            const index = paths.findIndex(item => this.fromPath.includes(item));
            this.goOtherPage(index !== -1 ? this.fromPath : '/login');
        },
        // 确认
        confirm() {
            if (!this.isPasswordValid()) return;
            const param = {
                vcode: this.code,
                password: this.password,
                [this.type === 1 ? 'mobile' : 'email']: this.account
            };
            const resetFunction = this.type === 1 ? resetPhonePwd : resetEmailPwd;
            this.resetPassword(resetFunction, param);
        },
        isPasswordValid() {
            if (this.password.length < 6 || this.password.length > 12) {
                this.$toast(this.$t('login.findPassword.moreThan6Tips'));
                return false;
            }
            if (this.password !== this.confirmPassword) {
                this.$toast(this.$t('login.findPassword.twiceSame'));
                return false;
            }
            if (!this.code) {
                this.$toast(this.$t('register.entryCodeTips'));
                return false;
            }
            return true;
        },
        resetPassword(fun, param) {
            fun(param).then(res => {
                if (res.code === 0 || res.code === '0') {
                    localStorage.setItem('dlInfo', JSON.stringify({ account: this.account }));
                    this.$toast(this.$t('common.eidtSuccess'));
                    this.$router.push('/login');
                } else if (res.msg) {
                    this.$toast(res.msg);
                }
            }).catch(() => {});
        },
        // 获取验证码
        sendVcode() {
            if (!this.isGetCode) return;
            const uid = localStorage.getItem('uid') || utils.guid();
            const param = {
                mobile: this.account,
                type: 3,
                os: 0,
                sign: md5(`${uid}jgyh,kasd${new Date().getTime()}`),
                timestamp: new Date().getTime(),
                udid: uid
            };
            const sendFunction = this.type === 1 ? sendVcode : sendEmailVcode;
            this.requestVcode(sendFunction, param);
        },
        requestVcode(fun, param) {
            fun(param).then(res => {
                if (res.code === 0 || res.code === '0') {
                    this.$toast(this.$t('common.getCodeSuccess'));
                    this.startTimer();
                } else {
                    this.resetTimer();
                    if (res.msg) this.$toast(res.msg);
                }
            }).catch(() => this.resetTimer());
        },
        startTimer() {
            let time = 179;
            this.isGetCode = false;
            this.timer = setInterval(() => {
                if (time > 0) {
                    time--;
                    this.getCodeVal = `${time}s`;
                } else {
                    this.resetTimer();
                }
            }, 1000);
        },
        resetTimer() {
            clearInterval(this.timer);
            this.getCodeVal = this.$t('common.getCode');
            this.isGetCode = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.findPassword {
    color: #333;
    padding-top: 0.88rem;
    background-color: #fff;

    .findPasswordBox {
        padding: 0.2rem 0.28rem 0;
        text-align: left;

        .infoConfirm {
            margin: 0.8rem auto 0;
        }

        .sexLoginPsw {
            margin-top: 0.6rem;
        }

        .pswTip {
            font-size: 0.24rem;
            margin-top: 0.1rem;
        }
    }
}</style>
<style lang="scss">.findPassword {
    .van-cell {
        border-bottom: 1px solid #ebeff1;
        padding-left: 0 !important;
    }
}</style>